import React from 'react';
import Select from 'react-select';
import './react-select.css';

export default class ReactSelect extends React.Component{    

    render(){
        const height = this.props.height? `${this.props.height.toString()}px` : '25px'
        return(
            
            < Select style={{height:height}}  value={this.props.value} searchable={this.props.searchable} placeholder='Seleccione...' noResultsText='No existen resultados' searchPromptText='Escriba para buscar'
            onChange={this.props.func_onChange} onBlur={this.props.func_onBlur} options={this.props.options} inputProps={this.props.inputProps}
            onFocus={this.props.func_onFocus} disabled={this.props.disabled}/>
        )
    }
}    
    
